const NoCaptures = (props) => {
  return (
    <div className="row">
      
      <div className="col-lg-12 text-center my-5">
          <h3>Everything's A-OK</h3>
          <p>No errors have been captured.</p>
          <p>Any status code 400 or greater will be displayed here.</p>
      </div>  
    </div>  

  );
}

export default NoCaptures;